import React from 'react'
import HobnobModal from 'components/common/HobnobModalV2/HobnobModal'
import PropTypes from 'prop-types'
import styles from './download-app-modal.scss'
import Button from 'components/common/Button'
import LogoRectangle from 'assets/icons/logo-rectangle.png'
import { DOWNLOAD_APP_LINK } from 'src/constants'
import AppleIcon from 'assets/icons/apple-icon-white.png'
import classnames from 'classnames'

const DownloadAppModal = ({
  show,
  onClose,
  title,
  showAppleIcon,
  buttonText = 'Download Hobnob App',
  href = DOWNLOAD_APP_LINK,
  buttonClassName
}) => {
  return (
    <HobnobModal
      visible={show}
      onClose={onClose}
      closable={false}
      fullModal
    >
      <div className={styles['download-wrapper']}>
        <img src={LogoRectangle} alt="" />
        <div className={styles['text']}>{title}</div>
        <Button wrapperElement={'a'} href={href} target="_blank" rel="noreferrer" className={classnames(styles['button-inner'], buttonClassName)}>
          {
            showAppleIcon && <img src={AppleIcon} alt='Apple Icon' />
          }
          <strong>{buttonText}</strong>
        </Button>

        <div className={styles['close-text']} onClick={onClose}>
          No, thanks
        </div>
      </div>
    </HobnobModal>
  )
}

DownloadAppModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  showAppleIcon: PropTypes.bool,
  buttonText: PropTypes.string,
  href: PropTypes.string,
  buttonClassName: PropTypes.string
}

export default DownloadAppModal
